import { useMemo } from "react";

import TableSimpleCell from "ds/components/TableSimple/Cell";
import SpacePath from "components/SpacePath";
import { Context } from "types/generated";
import { ContextSuggestions } from "shared/Context/constants";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import useCellFilterAction from "../useCellFilterAction";

const ContextsTableSpaceCell = ({ item: context, ...cellProps }: TableSimpleCellProps<Context>) => {
  const spaceFilterAction = useCellFilterAction({
    filterName: ContextSuggestions.Space,
    filterValue: context.spaceDetails.id,
    spaceCell: true,
  });

  const actions = useMemo(() => [spaceFilterAction], [spaceFilterAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <SpacePath spaceId={context.spaceDetails.id} fallbackName={context.spaceDetails.name} />
    </TableSimpleCell>
  );
};

export default ContextsTableSpaceCell;
